
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as about_45andywYMkCswsdDMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/about-andy.vue?macro=true";
import { default as andy_45guitar_45apposbaO0mXAiMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/andy-guitar-app.vue?macro=true";
import { default as brand_45guidelinesi4e3lbvVepMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/brand-guidelines.vue?macro=true";
import { default as cookiesK2prxTIpo5Meta } from "/codebuild/output/src4114972289/src/nuxt/pages/cookies.vue?macro=true";
import { default as _91courseSlug_93RCUeTmoGoyMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/courses/[courseSlug].vue?macro=true";
import { default as indexM9aZ0dK2mmMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/courses/index.vue?macro=true";
import { default as donations3noxGSNN5wMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/donations.vue?macro=true";
import { default as events7NsRrO9mUCMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/events.vue?macro=true";
import { default as featuresNfy9VL0I8pMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/features.vue?macro=true";
import { default as free_45christmas_45mini_45songbookCpOzQ5GbjVMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/free-christmas-mini-songbook.vue?macro=true";
import { default as free_45resourcesEyZZKYxrO3Meta } from "/codebuild/output/src4114972289/src/nuxt/pages/free-resources.vue?macro=true";
import { default as _91categorySlug_93gz3RjwyIVtMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/helpdesk/[categorySlug].vue?macro=true";
import { default as indexaHwaJnobjEMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/helpdesk/index.vue?macro=true";
import { default as indexN56xNnac8TMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/index.vue?macro=true";
import { default as _91streamSlug_93NWJjbrgTRmMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/live/[streamSlug].vue?macro=true";
import { default as indexiDuUtUq1adMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/live/index.vue?macro=true";
import { default as indexRd2T5gGS1oMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/login-code/index.vue?macro=true";
import { default as _91passcode_93gATN3Gl4knMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/login/index/[passcode].vue?macro=true";
import { default as indexXqR8Mul2pXMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/login/index.vue?macro=true";
import { default as edit6yxRKsVEkXMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/me/edit.vue?macro=true";
import { default as index2modmZvLalMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/me/index.vue?macro=true";
import { default as notificationsgeaCQH1zVBMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/me/notifications.vue?macro=true";
import { default as canceli1vxJIOTbnMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/me/subscriptions/[idSubscription]/cancel.vue?macro=true";
import { default as indexo6dgl7BVuBMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/me/subscriptions/[idSubscription]/index.vue?macro=true";
import { default as membershiphJ3OEPoa5MMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/membership.vue?macro=true";
import { default as _91token_93m0dCBl2hibMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/messages/index/[idThread]/[token].vue?macro=true";
import { default as _91idThread_93FPrKZ9xN6HMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/messages/index/[idThread].vue?macro=true";
import { default as indexKDUH4IQIvsMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/messages/index.vue?macro=true";
import { default as my_45listm8gl3de6uyMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/my-list.vue?macro=true";
import { default as privacyxHXPjy7ctbMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/privacy.vue?macro=true";
import { default as signature_45productsFQepLOJJ9OMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/signature-products.vue?macro=true";
import { default as signupc7Ofqv4l9AMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/signup.vue?macro=true";
import { default as termsodG6FYE8Y6Meta } from "/codebuild/output/src4114972289/src/nuxt/pages/terms.vue?macro=true";
import { default as _91token_93Ej0Ky5hbYBMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/unsubscribe-mailers/[email]/[token].vue?macro=true";
import { default as _91token_93UkEpXBJvVOMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/unsubscribe/[email]/[token].vue?macro=true";
import { default as _91lessonSlug_93wd1k4zz6AnMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/videos/[lessonSlug].vue?macro=true";
import { default as index8EvSU7cVwuMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/videos/index.vue?macro=true";
import { default as welcomeD268nmhVwUMeta } from "/codebuild/output/src4114972289/src/nuxt/pages/welcome.vue?macro=true";
export default [
  {
    name: "about-andy",
    path: "/about-andy",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/about-andy.vue")
  },
  {
    name: "andy-guitar-app",
    path: "/andy-guitar-app",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/andy-guitar-app.vue")
  },
  {
    name: "brand-guidelines",
    path: "/brand-guidelines",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/brand-guidelines.vue")
  },
  {
    name: "cookies",
    path: "/cookies",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/cookies.vue")
  },
  {
    name: "courses-courseSlug",
    path: "/courses/:courseSlug()",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/courses/[courseSlug].vue")
  },
  {
    name: "courses",
    path: "/courses",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/courses/index.vue")
  },
  {
    name: "donations",
    path: "/donations",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/donations.vue")
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/events.vue")
  },
  {
    name: "features",
    path: "/features",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/features.vue")
  },
  {
    name: "free-christmas-mini-songbook",
    path: "/free-christmas-mini-songbook",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/free-christmas-mini-songbook.vue")
  },
  {
    name: "free-resources",
    path: "/free-resources",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/free-resources.vue")
  },
  {
    name: "helpdesk-categorySlug",
    path: "/helpdesk/:categorySlug()",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/helpdesk/[categorySlug].vue")
  },
  {
    name: "helpdesk",
    path: "/helpdesk",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/helpdesk/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/index.vue")
  },
  {
    name: "live-streamSlug",
    path: "/live/:streamSlug()",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/live/[streamSlug].vue")
  },
  {
    name: "live",
    path: "/live",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/live/index.vue")
  },
  {
    name: "login-code",
    path: "/login-code",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/login-code/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/login/index.vue"),
    children: [
  {
    name: "login-index-passcode",
    path: ":passcode()",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/login/index/[passcode].vue")
  }
]
  },
  {
    name: "me-edit",
    path: "/me/edit",
    meta: edit6yxRKsVEkXMeta || {},
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/me/edit.vue")
  },
  {
    name: "me",
    path: "/me",
    meta: index2modmZvLalMeta || {},
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/me/index.vue")
  },
  {
    name: "me-notifications",
    path: "/me/notifications",
    meta: notificationsgeaCQH1zVBMeta || {},
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/me/notifications.vue")
  },
  {
    name: "me-subscriptions-idSubscription-cancel",
    path: "/me/subscriptions/:idSubscription()/cancel",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/me/subscriptions/[idSubscription]/cancel.vue")
  },
  {
    name: "me-subscriptions-idSubscription",
    path: "/me/subscriptions/:idSubscription()",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/me/subscriptions/[idSubscription]/index.vue")
  },
  {
    name: "membership",
    path: "/membership",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/membership.vue")
  },
  {
    name: "messages",
    path: "/messages",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/messages/index.vue"),
    children: [
  {
    name: "messages-index-idThread",
    path: ":idThread()",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/messages/index/[idThread].vue"),
    children: [
  {
    name: "messages-index-idThread-token",
    path: ":token()",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/messages/index/[idThread]/[token].vue")
  }
]
  }
]
  },
  {
    name: "my-list",
    path: "/my-list",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/my-list.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/privacy.vue")
  },
  {
    name: "signature-products",
    path: "/signature-products",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/signature-products.vue")
  },
  {
    name: "signup",
    path: "/signup",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/signup.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/terms.vue")
  },
  {
    name: "unsubscribe-mailers-email-token",
    path: "/unsubscribe-mailers/:email()/:token()",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/unsubscribe-mailers/[email]/[token].vue")
  },
  {
    name: "unsubscribe-email-token",
    path: "/unsubscribe/:email()/:token()",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/unsubscribe/[email]/[token].vue")
  },
  {
    name: "videos-lessonSlug",
    path: "/videos/:lessonSlug()",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/videos/[lessonSlug].vue")
  },
  {
    name: "videos",
    path: "/videos",
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/videos/index.vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    meta: welcomeD268nmhVwUMeta || {},
    component: () => import("/codebuild/output/src4114972289/src/nuxt/pages/welcome.vue")
  }
]